import React, { Fragment, useState, useCallback } from "react";
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Row,
  Card,
  CardBody,
  CardTitle,
  CardText,
  Button
} from "reactstrap";
import classnames from "classnames";
import IntlMessages from "Util/IntlMessages";

import { Colxx, Separator } from "Components/CustomBootstrap";
import BreadcrumbContainer from "Components/BreadcrumbContainer";

export default function Tabs() {
  const [activetab, setActivetab] = useState("1");

  const toggle = useCallback((tab: string) => {
    setActivetab((current) => (current !== tab ? tab : current));
  }, []);

  return (
    <Fragment>
      <Row>
        <Colxx xxs="12">
          <BreadcrumbContainer
            heading={<IntlMessages id="menu.tabs" />}
          />
          <Separator className="mb-5" />
        </Colxx>
      </Row>
      <Row>
        <Colxx xxs="12">
          <Card className="mb-4">
            <CardBody>
              <CardTitle>
                <IntlMessages id="menu.badges" />
              </CardTitle>
              <Nav tabs>
                <NavItem>
                  <NavLink
                    className={classnames({
                      active: activetab === "1"
                    })}
                    onClick={() => {
                      toggle("1");
                    }}
                  >
                    About
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({
                      active: activetab === "2"
                    })}
                    onClick={() => {
                      toggle("2");
                    }}
                  >
                    More Tabs
                  </NavLink>
                </NavItem>
              </Nav>
              <TabContent activeTab={activetab}>
                <TabPane tabId="1">
                  <Row>
                    <Colxx sm="12" className="mt-4">
                      <h4>About React</h4>
                      <p>
                        React makes it painless to create interactive UIs.
                        Design simple views for each state in your
                        application, and React will efficiently update and
                        render just the right components when your data
                        changes. Declarative views make your code more
                        predictable and easier to debug.
                      </p>
                    </Colxx>
                  </Row>
                </TabPane>
                <TabPane tabId="2">
                  <Row>
                    <Colxx sm="6">
                      <Card body>
                        <CardTitle>Special Title Treatment</CardTitle>
                        <CardText>
                          With supporting text below as a natural lead-in to
                          additional content.
                        </CardText>
                        <Button color="primary">Go somewhere</Button>
                      </Card>
                    </Colxx>
                    <Colxx sm="6">
                      <Card body>
                        <CardTitle>Special Title Treatment</CardTitle>
                        <CardText>
                          With supporting text below as a natural lead-in to
                          additional content.
                        </CardText>
                        <Button color="primary">Go somewhere</Button>
                      </Card>
                    </Colxx>
                  </Row>
                </TabPane>
              </TabContent>
            </CardBody>
          </Card>

          {/* Tab 2 */}
          <Card className="mb-4">
            <CardBody>
              <CardTitle>
                <IntlMessages id="button.with-badges" />
              </CardTitle>
              <Row>
                <Colxx lg="4">
                  <Nav className="display-block mt-4" tabs>
                    <NavItem>
                      <NavLink
                        className={classnames({
                          active: activetab === "1"
                        })}
                        onClick={() => {
                          toggle("1");
                        }}
                      >
                        About
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({
                          active: activetab === "4"
                        })}
                        onClick={() => {
                          toggle("4");
                        }}
                      >
                        More Tabs
                      </NavLink>
                    </NavItem>
                  </Nav>
                </Colxx>
                <Colxx lg="8">
                  <TabContent activeTab={activetab}>
                    <TabPane tabId="1">
                      <Row>
                        <Colxx sm="12" className="mt-4">
                          <h4>About React</h4>
                          <p>
                            React makes it painless to create interactive UIs.
                            Design simple views for each state in your
                            application, and React will efficiently update and
                            render just the right components when your data
                            changes. Declarative views make your code more
                            predictable and easier to debug.
                          </p>
                        </Colxx>
                      </Row>
                    </TabPane>
                    <TabPane tabId="4">
                      <Row>
                        <Colxx sm="6">
                          <Card body>
                            <CardTitle>Special Title Treatment</CardTitle>
                            <CardText>
                              With supporting text below as a natural lead-in
                              to additional content.
                            </CardText>
                            <Button color="primary">Go somewhere</Button>
                          </Card>
                        </Colxx>
                        <Colxx sm="6">
                          <Card body>
                            <CardTitle>Special Title Treatment</CardTitle>
                            <CardText>
                              With supporting text below as a natural lead-in
                              to additional content.
                            </CardText>
                            <Button color="primary">Go somewhere</Button>
                          </Card>
                        </Colxx>
                      </Row>
                    </TabPane>
                  </TabContent>
                </Colxx>
              </Row>
            </CardBody>
          </Card>
        </Colxx>
      </Row>
    </Fragment>
  );
}
